import React from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.jpg';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <Fade>
            <div className="top-section">
              <div className="left">
                <p className="about__subheading">
                  Hi 👋, I am <span>Aniket Pathak</span>
                </p>
                <h2 className="about__heading">
                  A Full Stack Web Developer in making...
                </h2>
                <div className="about__info">
                  <PText>
                    I am from Kolkata, India, often known as the "City of Joy."
                    I like to introducing myself as a self-taught, highly
                    motivated, aspiring developer who is committed to achieving
                    his goal of being a Full Stack Developer one day.
                    <br /> <br />
                    When I first used a computer in 2007, I fell in love with
                    technology. I've always been curious about it and what goes
                    on behind the scenes since then. Despite my interest, I
                    didn't begin my developer career until recently, in my
                    freshman year of college. I had very little, if any,
                    programming experience. I taught myself to code with the
                    help of tutorials, documentation, and a lot of trial and
                    error.
                    <br />
                    <br />
                    Technology, I believe, is the most powerful resource in this
                    century, and it has the potential to change the world for
                    the better. Technology, on the other hand, is meaningless
                    without great developers who use it to make it meaningful.
                    My ambition is to become one of those developers, and to use
                    my knowledge and skills to make the world a better place.
                  </PText>
                </div>
                <Button btnText="Download CV" btnLink="#" />
              </div>
              <div className="right">
                <img src={AboutImg} alt="me" />
              </div>
            </div>
          </Fade>
          <Fade>
            <div className="about__info__items">
              <div className="about__info__item">
                <h1 className="about__info__heading">Education</h1>

                <AboutInfoItem
                  title="College"
                  items={[
                    'BTech in Computer Science and Engineering',
                    'Kalinga Institute of Industrial Technology, Bhubaneshwar',
                  ]}
                />
                <AboutInfoItem
                  title="School"
                  items={['Delhi Public School Ruby Park, Kolkata']}
                />
              </div>
              <div className="about__info__item">
                <h1 className="about__info__heading">My Skills</h1>

                <AboutInfoItem
                  title="FrontEnd"
                  items={['HTML', 'CSS', 'JavaScript', 'React.js']}
                />
                <AboutInfoItem
                  title="BackEnd"
                  items={['Node', 'Express', 'EJS', 'MongoDB']}
                />
                <AboutInfoItem title="Others" items={['C', 'C++']} />
              </div>
            </div>
          </Fade>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
